import React from 'react'
import { Typography } from '@mui/material'
import Callout from '../Common/callout/Callout'
import { defaultPalette } from '../../theme/idsTheme'

const WorkbenchCallout: React.FC = () => (
    <Callout color={defaultPalette.orangeWarning.main}>
        <Typography>
            Le statut INS du patient a été rétrogradé du statut “qualifié” à “provisoire” car l’un de ses cinq traits
            stricts d’identité a changé. Veuillez mettre à jour les informations du patient et relancer un appel pour
            récupérer son INS.
        </Typography>
    </Callout>
)

export default WorkbenchCallout
